export default __webpack_public_path__ + "static/125-386c613d88f7c414b5468c7d2bbd0f6c.jpg";